import { createFileRoute } from '@tanstack/react-router';

import { CrosswordEditPage } from '@/components/admin/crossword-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetCrosswordPuzzleFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/crossword_/$id')({
    component: CrosswordEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'לוח תשחץ חדש' : 'עריכת לוח תשחץ',
            `/admin/crossword/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetCrosswordPuzzleFn({ data: { id: params.id } });
    },
});

function CrosswordEditRoute() {
    const puzzle = Route.useLoaderData();
    const formKey = useAdminEditPageKey(
        puzzle ? `${puzzle.id}:${String(puzzle.updatedAt)}` : undefined,
    );
    return <CrosswordEditPage key={formKey} puzzle={puzzle} />;
}
